import { ForgotPasswordMessages, TranslationForgotPasswordMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationForgotPasswordMessages = {
  [ForgotPasswordMessages.forgotPasswordRequiredEmail]: "Correo electrónico es requerido",
  [ForgotPasswordMessages.forgotPasswordInvalidEmail]: "Correo electrónico inválido",
  [ForgotPasswordMessages.forgotPasswordEmailLabel]: "Correo electrónico",
  [ForgotPasswordMessages.forgotPasswordTitlePage]: "Olvidé mi contraseña",
  [ForgotPasswordMessages.forgotPasswordButton]: "Enviar correo electrónico"
};
